'use client';

import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

interface ConditionBatteryStatusProps extends PropsWithChildren {
  charging?: string;
  notCharging?: string;
  unknown?: string;
}

export const ConditionBatteryStatus: FC<ConditionBatteryStatusProps> = ({
  charging,
  notCharging,
  unknown,
  children,
}) => {
  const { dataBlocks } = useTruth();
  const { batteryLevel, batteryChargingStatus } = dataBlocks;
  const { DataPopup } = useDataPopup();
  const [handle, setHandle] = useState<React.ReactNode>(children);

  useEffect(() => {
    if (typeof batteryChargingStatus?.value === 'undefined') {
      setHandle(unknown);
    } else if (batteryChargingStatus.value) {
      setHandle(charging);
    } else if (!batteryChargingStatus.value) {
      setHandle(notCharging);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- possibly stale: keyed on batteryLevel but reads batteryChargingStatus, see PR
  }, [batteryLevel?.value]);

  return (
    <DataPopup
      handle={handle}
      condition={{
        title: messages['condition.batteryChargingStatus'],
        options: [
          {
            title: messages['condition.batteryChargingStatus.charging'],
            value: charging,
          },
          {
            title: messages['condition.batteryChargingStatus.notCharging'],
            value: notCharging,
          },
          {
            title: messages['condition.batteryChargingStatus.unknown'],
            value: unknown,
          },
        ],
      }}
      dataBlocks={{ batteryLevel, batteryChargingStatus }}
    />
  );
};
